import React from "react";
import { Table } from "antd";
import { useSettingModel } from "../SettingModel";
import { ColumnsType } from "antd/es/table";
import { IMdSetting } from "../SettingTypes";

const columns: ColumnsType<IMdSetting> = [
    {
        align: 'center',
        title: '序号',
        width: 60,
        render: (v, r, i) => i + 1
    },
    {
        align: "center",
        title: '分支编码',
        // width: 100,
        dataIndex: 'branch',
    },
    {
        align: "center",
        title: '数据版本号',
        // width: 100,
        dataIndex: 'ver',
    },
    {
        align: "center",
        title: '配置编码',
        // width: 150,
        dataIndex: 'code',
    },
    {
        align: "center",
        title: '配置的值',
        dataIndex: 'value',
    },
    {
        align: "center",
        title: '备注',
        // width: 120,
        dataIndex: 'note',
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'enable',
        // width: 120,
        render: (v) => v === 0 ? "关闭" : "开启"
    },

];

export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
    } = useSettingModel();


    return (
        <Table
            style={{ cursor: "pointer" }}
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IMdSetting[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
        // onRow={record => {
        //     return {
        //         onClick: event => {
        //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
        //                 setSelectedRowKeys([]);
        //             } else {
        //                 setSelectedRowKeys([record.key]);
        //             }
        //         },
        //     };
        // }}
        />
    )
}
